import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { DeliveryAreaService } from '../delivery-area.service';
import { DeliveryAcceleratorsService } from './delivery-accelerators.service';
import { DeliveryAcceleratorsTab1Part } from './tabs/tab-1/delivery-accelerators-tab-1.part';
import { DeliveryAcceleratorsTab2Part } from './tabs/tab-2/delivery-accelerators-tab-2.part';
import { DeliveryAcceleratorsViewsPart } from './views/accelerators-views.part';

@Component({
	selector: 'delivery-accelerators-page',
	standalone: true,
	imports: [
		DeliveryAcceleratorsViewsPart,
		DeliveryAcceleratorsTab1Part,
		DeliveryAcceleratorsTab2Part,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery-accelerators.page.html',
})
export class DeliveryAcceleratorsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;
	public areaService = inject(DeliveryAreaService);

	constructor(public pageService: DeliveryAcceleratorsService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}